import { render, staticRenderFns } from "./AppInputFile.vue?vue&type=template&id=c8b87bb2&scoped=true&"
import script from "./AppInputFile.vue?vue&type=script&lang=ts&"
export * from "./AppInputFile.vue?vue&type=script&lang=ts&"
import style0 from "./AppInputFile.vue?vue&type=style&index=0&id=c8b87bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b87bb2",
  null
  
)

export default component.exports